<template>
  <div class="main mplus maisy">
    <Header class="header-component" page="schedule"></Header>
    <div class="schedule box">
      <div class="schedule-title josefin title-text uppercase maisy">
        schedule & ticket
      </div>
      <div class="schedule-inner box">
        <div class="head narrow maisy"><span class="head-text mplus">公演スケジュール</span></div>
        <div class="dates josefin">2023 7.15<span class="day">Sat</span><span class="arrow mplus">▶︎</span>8.6<span
            class="day">Sun</span>
        </div>
        <div class="place mplus">品川プリンスホテル クラブeX</div>
        <div class="url josefin"><a href="https://www.princehotels.co.jp/shinagawa/clubex/" target="_blank"
            rel="noopener noreferrer" class="break-all">https://www.princehotels.co.jp/shinagawa/clubex/</a></div>
      </div>
      <div class="table box">
        <div class="row">
          <div class="date"></div>
          <div class="time">13:00</div>
          <div class="time">14:00</div>
          <div class="time">18:00</div>
          <div class="time">19:00</div>
        </div>
        <div class="row" v-for="(item, index) in $store.state.schedule" :key="`schedule-${index}`">
          <div class="date">
            <div class="month" v-html="month(item.date)"></div>
            <div class="day" v-html="day(item.date)"
              :class="[{ 'orange-text': isHoliday(item.date) }, { off: !item.events }, { ml: isOneDigit(item.date) }]">
            </div>
          </div>
          <template v-if="item.events">
            <template v-for="(event, index) in item.events">
              <div :key="`event-${index}`" v-html="eventText(event)"
                :class="[eventColor(event), present(event, item.present, index)]" class="event"></div>
            </template>
          </template>
          <template v-else>
            <div v-for="i in 4" :key="`off-${i}`" class="event off"></div>
          </template>
        </div>
      </div>
    </div>
    <div class="curtain box">
      <div class="head">【全公演】スマホ撮影可能の<br class="brsp">スペシャルカーテンコール実施！</div>
      <span class="bolder">今回も全公演、写真・動画撮影OKのスペシャルカーテンコールを実施いたします！</span><br />
      ぜひ「#ジュエステカテコ」のハッシュタグをつけてSNSに投稿してください！<br />
      <span class="sq">■</span> <span class="bolder">対象公演</span>：全公演<br />
      <span class="sq">■</span> <span class="bolder">注意事項</span><br />
      携帯電話・スマートフォンのみ撮影可能。一眼レフカメラなどのカメラ機材はご使用いただけません。<br />
      フラッシュのご使用は、ほかのお客様のご迷惑になりますのでお控えください。<br />
      公演中指示があるまでは、スマートフォン・携帯電話は電源からお切りくださいますようお願いいたします。
    </div>
    <div class="bonus box">
      <div class="head">入場者特典</div>
      <span class="bolder"><span class="orange-text">対象公演（公演スケジュール内<img :src="'img/maisy/circle-coaster.svg'"
            class="circle" alt=""><img :src="'img/refly/circle-coaster.svg'" class="circle" alt=""><img
            :src="'img/emekare/circle-coaster.svg'" class="circle" alt="">印）のご来場者全員</span>に、各ユニットの<span
          class="orange-text">原作描き下ろしイラストを使用したコースター（非売品）</span>を1枚プレゼント！</span><br />
      <img :src="'img/maisy/circle-coaster.svg'" class="circle" alt="">MAISY公演はMAISYのイラスト5種、<img
        :src="'img/refly/circle-coaster.svg'" class="circle" alt="">Re:Fly公演はRe:Flyのイラスト5種、<img
        :src="'img/emekare/circle-coaster.svg'" class="circle" alt="">エメ☆カレ公演はエメ☆カレのイラスト5種を、各回ランダムでお渡しいたします。<br />
      <ul>
        <li>※対象公演はスケジュールをご確認ください。</li>
      </ul>
      <hr class="divider" />
      このほか、<span class="bolder orange-text">［席種特典］［回数別特典：<span
          class="black-text bolder">３ユニット観劇特典／同じユニット5回観劇特典／同じユニット全通特典</span>］</span>などの情報は以下のページをご覧ください！
      <router-link class="event-link-box" tag="div" :to="`/event`" key="1">
        <div class="text josefin">event & present</div>
        <div class="copy">イベント・特典情報</div>
      </router-link>
    </div>
    <div class="divider wide"></div>
    <div class="ticket box mplus">
      <div class="head">チケット料金<span class="smaller">（全席指定／税込）</span></div>
      <div class="item"><span class="bolder"><span class="seat-s">S席</span>&nbsp;…………………15,000円</span><br class="brsp">（1F
        1〜3列目／シークレットライブ・お見送り付）</div>
      <div class="item"><span class="bolder">A席……………………9,500円</span><br class="brsp">（1F 4〜5列目／お見送り付）</div>
      <div class="item"><span class="bolder"><span class="seat-b">B席</span>……………………5,500円</span><br class="brsp">（1F
        6〜7列目）</div>
      <div class="item"><span class="bolder"><span class="bench">1Fベンチシート</span>&nbsp;…10,000円</span><br
          class="brsp">（お見送り付）</div>
      <div class="item"><span class="bolder"><span class="seat-2f">2F席</span>&nbsp;&nbsp;………………11,000円</span><br
          class="brsp">（シークレットライブ・お見送り付）</div>
      <div class="ticket-note">
        <ul>
          <li><span class="sq">※</span>各席種特典については<router-link class="event-link orange-text" tag="span" :to="`/event`"
              key="1">【event & present】</router-link>をご確認ください。</li>
        </ul>
      </div>
    </div>
    <div class="ticket-early box mplus">
      <div class="head">先行スケジュール</div>
      <div class="item"><span class="sq">■</span><span class="bolder">『オンエア！』公式サイト先行（抽選）</span><br />
        <a href="http://on-air-coly.com/news/jewelstage-mre_game/" target="_blank"
          rel="noopener noreferrer">http://on-air-coly.com/news/jewelstage-mre_game/</a><br />
        受付期間：<time datetime="2023-05-17T20:00">2023年5月17日(水)20:00</time>～<time
          datetime="2023-05-23T23:59">5月23日(火)23:59</time><br />
        結果発表：<time datetime="2023-05-27T15:00">2023年5月27日(土)15:00</time>
      </div>
      <div class="item">
        <span class="sq">■</span><span class="bolder">舞台オフィシャル先行（抽選）</span><br />
        <a href="https://l-tike.com/st1/onair-stage-mre-official" target="_blank"
          rel="noopener noreferrer">https://l-tike.com/st1/onair-stage-mre-official</a><br />
        受付期間：<time datetime="2023-05-17T20:00">2023年5月17日(水)20:00</time>～<time
          datetime="2023-05-23T23:59">5月23日(火)23:59</time><br />
        結果発表：<time datetime="2023-05-27T15:00">2023年5月27日(土)15:00</time><br />
      </div>
      <div class="item">
        <span class="sq">■</span><span class="bolder">ネルケハ！先行（抽選）</span><br />
        <a href="https://www.nelke.co.jp/member/" target="_blank"
          rel="noopener noreferrer">https://www.nelke.co.jp/member/</a><br />
        受付期間：<time datetime="2023-05-17T20:00">2023年5月17日(水)20:00</time>～<time
          datetime="2023-05-23T23:59">5月23日(火)23:59</time><br />
        結果発表：<time datetime="2023-05-27T15:00">2023年5月27日(土)15:00</time><br />
        <ul>
          <li>※ネルケハ！会員の方が対象となります。</li>
          <li>※既に会員登録済みの方も、エントリー期間中に新規登録いただいた方もお申し込みいただけます。</li>
        </ul>
      </div>
      <div class="item">
        <span class="sq">■</span><span class="bolder">2.5フレンズ先行（抽選）</span><br />
        <a href="https://www.j25musical.jp/friends/" target="_blank"
          rel="noopener noreferrer">https://www.j25musical.jp/friends/</a><br />
        受付期間：<time datetime="2023-05-26T12:00">2023年5月26日(金)12:00</time>～<time
          datetime="2023-05-30T23:59">5月30日(火)23:59</time><br />
        結果発表：<time datetime="2023-06-03T15:00">2023年6月3日(土)15:00</time><br />
        <ul>
          <li>※2.5フレンズ会員の方が対象となります。</li>
          <li>※既に会員登録済みの方も、エントリー期間中に新規登録いただいた方もお申し込みいただけます。</li>
        </ul>
      </div>
      <div class="item">
        <span class="sq">■</span><span class="bolder">キャスト先行（抽選）</span><br />
        受付期間：<time datetime="2023-05-26T12:00">2023年5月26日(金)12:00</time>～<time
          datetime="2023-05-30T23:59">5月30日(火)23:59</time><br />
        結果発表：<time datetime="2023-06-03T15:00">2023年6月3日(土)15:00</time><br />
        <ul>
          <li>※先行実施有無等の詳細は各キャストの公式サイト・公式Twitterにてご確認ください。</li>
        </ul>
      </div>
    </div>
    <div class="ticket-playguide box mplus">
      <div class="head">プレイガイド情報</div>
      <div class="item"><span class="sq">■</span><span class="bolder">LEncore先行（抽選）</span><br />
        <a href="https://l-tike.com/onair-stage-mre/" target="_blank"
          rel="noopener noreferrer">https://l-tike.com/onair-stage-mre/</a><br />
        受付期間：<time datetime="2023-06-02T12:00">2023年6月2日(金)12:00</time>～<time
          datetime="2023-06-06T23:59">6月6日(火)23:59</time><br />
        結果発表：<time datetime="2023-06-10T15:00">2023年6月10日(土)15:00</time><br />
        <ul>
          <li>※LEncore会員の方が対象となります。</li>
          <li>※LEncore先行のご利用には、事前にLEncoreカード（クレジットカード付き、年会費1,650円）へのお申し込みが必要となります。</li>
        </ul>
      </div>
      <div class="item"><span class="sq">■</span><span class="bolder">プレリクエスト先行（抽選）</span><br />
        <a href="https://l-tike.com/onair-stage-mre/" target="_blank"
          rel="noopener noreferrer">https://l-tike.com/onair-stage-mre/</a><br />
        受付期間：<time datetime="2023-06-02T12:00">2023年6月2日(金)12:00</time>～<time
          datetime="2023-06-06T23:59">6月6日(火)23:59</time><br />
        結果発表：<time datetime="2023-06-10T15:00">2023年6月10日(土)15:00</time><br />
        <ul>
          <li>※ローチケWEB会員の方が対象となります。</li>
        </ul>
      </div>
      <div class="item">
        <span class="sq">■</span><span class="bolder">プレリクエスト2次先行（抽選）</span><br />
        <a href="https://l-tike.com/onair-stage-mre/" target="_blank"
          rel="noopener noreferrer">https://l-tike.com/onair-stage-mre/</a><br />
        受付期間：<time datetime="2023-06-08T12:00">2023年6月8日(木)12:00</time>～<time
          datetime="2023-06-12T23:59">6月12日(月)23:59</time><br />
        結果発表：<time datetime="2023-06-15T15:00">2023年6月15日(木)15:00</time><br />
        <ul>
          <li>※ローチケWEB会員の方が対象となります。</li>
        </ul>
      </div>
      <div class="item">
        <span class="sq">■</span><span class="bolder">一般発売（先着）</span><br />
        <time datetime="2023-06-18T10:00">2023年6月18日(日)10:00</time><br />
        ＜ローソンチケット＞<br />
        <a href="https://l-tike.com/onair-stage-mre/" target="_blank"
          rel="noopener noreferrer">https://l-tike.com/onair-stage-mre/</a>&#x3000;<span
          class="smaller">※PC/スマートフォン共通</span><br />
        <span class="smaller">Lコード：35306</span>
      </div>
    </div>
    <div class="attention box">
      <div class="resale-inner" id="resale">
        <div class="head2 bolder align-center orange-text">チケットリセールについて</div>
        <div class="text">本公演は「チケトレ」にてチケットリセールを実施いたします。<br />
          チケトレとは？：<a href="https://tiketore.com/magazines/guide/beginner" target="_blank"
            rel="noopener noreferrer" class="break-all">https://tiketore.com/magazines/guide/beginner</a><br />
          <br />
          <div class="resale-text"><span class="bolder">＜リセール出品受付期限・販売期限＞</span><br />
            出品受付期限：各公演日10日前の<time datetime="23:59">23:59</time>まで<br />
            販売期限：出品され次第 ～ 各公演日7日前の<time datetime="23:59">23:59</time>まで<br />
            <br />
            例）<time datetime="2023-07-15">2023年7月15日(土)</time>公演チケットの出品・販売の場合<br />
            出品受付期限：<time datetime="2023-07-05T23:59">2023年7月5日(水)23:59</time>まで<br />
            販売期限：出品され次第 ～ <time datetime="2023-07-08T23:59">2023年7月8日(土)23:59</time><br />
            <br />
            <ul>
              <li>※発券済チケットのみご出品いただけます。</li>
              <li>※出品されたチケットは先着での販売となります。</li>
              <li>※ご購入者の身分証確認を公演当日入場時に行う場合がございますので、必ず、ご購入のチケット・チケトレ購入証明書・身分証の3点をご持参ください。</li>
              <li>※チケットリセールは、キャンセル・払い戻しではございません。購入したい人がいて初めて成立するものとなります。出品しても必ず成立するとは限りません。</li>
              <li>※出品・購入ともに、チケット代金以外に別途サービス利用手数料が必要となりますので、予めご了承ください。</li>
              <li>※「チケトレ」のご利用方法、出品・購入期限、出品・購入に伴うサービス利用料・手数料等の詳細につきましては、「チケトレ」サイトにてご確認ください。</li>
              <li>※チケットリセールは、お客様ご自身の責任においてご利用くださいますよう、お願い申し上げます。主催者は、そのご利用に伴う損害、不利益その他のトラブルについて、一切責任を負いかねます。</li>
            </ul>
          </div>
        </div>
      </div>
    <div class="divider wide"></div>
      <div class="attention-inner">
        <div class="head2 bolder align-center orange-text">注意事項</div>
        <div class="text">
          <ul>
            <li>※出演者及び公演スケジュールは予告なく変更となる場合がございます。</li>
            <li>※チケットにはお客様の氏名が印字されます。</li>
            <li>※ご購入時、チケット代の他に配送料・システム利用料等、各種手数料が必要となる場合がございます。</li>
            <li>※お席の場所によりましては舞台・映像・演出の一部が見えづらい場合がございます。</li>
            <li>※公演当日、劇場内の模様を撮影し、放送・配信・複製頒布等する場合がございます。</li>
            <li>※未就学児のご入場はご遠慮願います。</li>
            <li>※未成年者は、必ず保護者の承諾を得てからチケットのご購入とご来場をお願いいたします。夜の公演は終演時間が遅くなりますので、お帰りの時間にもご注意ください。</li>
            <li>※一度ご購入になられたチケットの変更・キャンセルはできません。<br />
              また、公演中止時以外の払い戻しは事情の如何に関わらず一切できません。天変地異及びそれに伴う交通機関トラブルの場合でも、公演が行われた際には払い戻しできませんのでご了承の上、お買い求めください。公演が中止になった場合には、公式サイトにて払い戻し方法をご案内いたします。
            </li>
            <li>※チケットは、紛失・破損・盗難などいかなる場合においても再発行はいたしません。チケットは大切に保管してください。お手元にあるチケットの日時を必ずご確認の上、ご来場ください。</li>
            <li>
              ※車椅子でご来場の際はお座席までのスムーズなご案内のため、チケットご購入後、必ずご観劇の2営業日前までにMitt（TEL：03-6265-3201／平日<time
                datetime="12:00">12:00</time>～<time
                datetime="17:00">17:00</time>）にご連絡ください。お連れ様がご観劇される場合もチケットは必要です。また、車椅子スペースはB席にございます都合上、シークレットライブやお見送り付チケットをご購入のお客様は、ご観劇はB席となりますが、ご購入いただいたチケットに応じたイベントに参加いただけます。
            </li>
            <li>※チケットは正規販売ルート（興行主催者、主催者より正式に販売許可を得たプレイガイド、ファンクラブなど）でご購入いただきますようお願いいたします。<br />
              チケットや座席番号等の譲渡・転売・その購入、及びそれらを試みる行為は権利無効であり、いかなる場合も固くお断りしております。正規販売ルート以外で購入されたチケット等に関しては、その有効性を一切保証されておりません。転売されたチケットや座席番号等は無効であり、ご入場をお断りさせていただく場合もございますので、ご注意ください。また、営利目的の譲渡・転売等、チケットや座席番号に関する不正行為やそれを疑われる行為が発覚した場合には本人確認を実施させていただく場合がございますので、ご来場時には必ず本人確認書類をご持参ください。
            </li>
          </ul>
        </div>
      </div>
      <div class="attention-info">
        <span class="bolder"><span class="sq">■</span>チケットに関するお問い合わせ</span><br />
        Mitt：03-6265-3201（平日<time datetime="12:00">12:00</time>～<time datetime="17:00">17:00</time>）
      </div>
      <div class="footer-bar">
        <div class="text box">©coly／ジュエルステージ「オンエア！」製作委員会</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
export default {
  name: "Schedule",
  components: {
    Header,
  },
  data: () => ({
    schedule: [{ "date": "2023-07-15", "events": ["", "", "m", ""] }, { "date": "2023-07-16", "events": ["", "", "e", ""] }, { "date": "2023-07-17", "events": ["", "", "r", ""] }, { "date": "2023-07-18", "off": true }, { "date": "2023-07-19", "events": ["", "e", "", "r"], "present": ["", "1", "", "1"] }, { "date": "2023-07-20", "events": ["", "m", "", ""], "present": ["", "1", "", ""] }, { "date": "2023-07-21", "events": ["", "r", "", "m"], "present": ["", "1", "", "1"] }, { "date": "2023-07-22", "events": ["e", "", "r", ""] }, { "date": "2023-07-23", "events": ["m", "", "e", ""] }, { "date": "2023-07-24", "off": true }, { "date": "2023-07-25", "events": ["", "m", "", "r"], "present": ["", "1", "", "1"] }, { "date": "2023-07-26", "events": ["", "r", "", "e"], "present": ["", "1", "", "1"] }, { "date": "2023-07-27", "events": ["", "e", "", ""], "present": ["", "1", "", ""] }, { "date": "2023-07-28", "events": ["", "r", "", "m"], "present": ["", "1", "", "1"] }, { "date": "2023-07-29", "events": ["e", "", "m", ""] }, { "date": "2023-07-30", "events": ["r", "", "", ""] }, { "date": "2023-07-31", "off": true }, { "date": "2023-08-01", "events": ["", "m", "", "r"], "present": ["", "1", "", ""] }, { "date": "2023-08-02", "events": ["", "e", "", ""], "present": ["", "1", "", ""] }, { "date": "2023-08-03", "events": ["", "m", "", "e"], "present": ["", "", "", "1"] }, { "date": "2023-08-04", "events": ["", "r", "", "m"] }, { "date": "2023-08-05", "events": ["e", "", "m", ""] }, { "date": "2023-08-06", "events": ["e", "", "r", ""] }],
    dayText: ["日", "月", "火", "水", "木", "金", "土"],
    eventBg: { "m": "maisyBg", "r": "reflyBg", "e": "emekareBg" },
    unitCode: { "m": "maisy", "r": "refly", "e": "emekare" }
  }
  ),
  methods: {
    month(date) {
      if (!date) { return; }
      let [, m,] = date.split('-');
      let firstday = "2023-07-15";
      let firstdayofAug = "2023-08-01";
      if (date === firstday || date === firstdayofAug) {
        let month = Number(m);
        return `${month}<span class="forpc">月</span><span class="forsp">/</span>`;
      }
    },
    day(date) {
      if (!date) { return; }
      let dt = new Date(date);
      let holiday = "2023-07-17";
      let dayofweek = this.dayText[dt.getDay()];
      let day = dt.getDate();
      let dayText = `${day}<span class="forpc">日</span>`;
      if (date === holiday) {
        return `${dayText}<span class="kakko">（${dayofweek}<span class="kakko2">・</span>祝）</span>`;
      } else {
        return `${dayText}<span class="kakko">（${dayofweek}）</span>`;
      }
    },
    isHoliday(date) {
      let holiday = "2023-07-17";
      let dt = new Date(date);
      let dayofweek = dt.getDay();

      if (dayofweek === 0 || date === holiday) {
        return true;

      }
    },
    eventText(event) {
      return this.$store.state.eventNames[event];
    },
    eventColor(event) {
      if (event) {
        return this.eventBg[event];
      } else {
        return 'blank';
      }
    },
    present(event, present, index) {
      let unit = this.unitCode[event];
      if (present) {
        if (present[index]) {
          return `${unit}-circle`;
        }
      }
      // return `../img/${unit}/circle-coaster.svg`;
    },
    presentImg(event) {
      let unit = this.unitCode[event];
      return `../img/${unit}/circle-coaster.svg`;
    },
    isOneDigit(date) {
      let [, , d] = date.split('-');
      if (Number(d) < 10) {
        return true;
      }
      return false;
    }
  },
  computed: {
    channelName() {
      let channel = this.$store.state.channel;
      return this.$store.state.channelNames[channel];
    },
  }
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  margin: 0 auto;
  position: relative;
  line-height: 1.7;

  @media screen and (max-width: 768px) {
    background-size: 200% auto !important;
    background-position: 50% 0 !important;
  }

  background: url(../../public/img/haikei_mre.jpg) repeat;
  background-size: 100% auto;
  background-position: 0 0;
  background-attachment: fixed;
}

.header-component {
  position: relative;
  z-index: 2;
}

.schedule {
  padding-top: 107px;
  position: relative;
  color: $black;
  font-size: 1.1rem;

  &-inner {
    padding-left: 4rem;
    padding-right: 4rem;
    text-align: left;
    color: $black;
    padding-bottom: 3rem;

    @media screen and (max-width: 768px) {
      padding-left: 1rem;
      padding-right: 1rem;
      padding-bottom: 1.5rem;
    }

    .dates {
      font-size: 2.6rem;
      margin-top: 1rem;

      @media screen and (max-width: 768px) {
        font-size: 2rem;
      }

      .day {
        font-size: 0.5em;
        // margin-right: 0.3em;
        margin-left: 0.3em;
      }

      .arrow {
        font-size: 0.5em;
        margin-right: 0.3em;
        margin-left: 0.3em;
      }
    }

    .place {
      font-size: 1.2rem;

      @media screen and (max-width: 768px) {
        margin-top: -0.5rem;
      }
    }

    .url {
      margin-top: 0rem;

      @media screen and (max-width: 768px) {
        font-size: 1rem;
      }
    }
  }
}

hr.divider {
  border: 0;
  border-top: 1px dotted $black;
  margin-top: 2rem;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}

.divider.wide {
  margin-top: 2rem;
}

.schedule-title {
  margin-top: 3rem;
  position: relative;

  .smaller {
    font-size: 0.6em;
  }

  &::before,
  &::after {
    position: absolute;
    content: "";
    background: url(../../public/img/maisy/title_maisy.png) no-repeat;
    width: 44px;
    height: 68px;
    bottom: 0;
    left: 4 * $rem;

    @media screen and (min-width: 1024px) {
      left: 4rem;
    }

    @media screen and (max-width: 768px) {
      left: 0;
      background-size: calc(44px * .8) calc(68px * .8);
      height: calc(68px * .8);
    }
  }

  &::after {
    transform: scaleX(-1);
    right: 4 * $rem;
    left: unset;

    @media screen and (max-width: 768px) {
      right: 0;
    }
    @media screen and (min-width: 1024px) {
      right: 4rem;
    }
  }
}

.head {
  margin-top: 4rem;
  width: 100%;
  background: linear-gradient(to right, $liteorange 50%, transparent);
  padding: 0.05rem 0.5rem 0.125rem;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  text-align: left;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    font-size: 1.1rem;
    background: linear-gradient(to right, $liteorange 80%, transparent);
    margin-top: 3rem;
    margin-bottom: 1rem;
    line-height: 1.4;
  }

  &.narrow {
    // width: 50%;
    margin-bottom: 0;
  }
}

.title-text {
  font-size: 2.5rem;
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1;

  @media screen and (max-width: 768px) {
    padding-top: 0;
    font-size: 1.6rem;
  }
}

.table {
  padding-left: 4rem;
  padding-right: 4rem;
  font-size: 1.1 * $rem;

  @media screen and (max-width: 768px) {
    padding-left: 0;
    padding-right: 1rem;
    font-size: 2 * $rem;
  }

  @media screen and (min-width: 1024px) {
    font-size: 1.1rem;
  }

  .row {
    display: flex;
    margin-bottom: 0.5 * $rem;
    position: relative;

    @media screen and (min-width: 1024px) {
      margin-bottom: 0.5rem;
    }
  }

  .date {
    width: 20%;
    display: flex;
    justify-content: flex-start;
    font-weight: 600;

    @media screen and (max-width: 768px) {
      width: 29%;
    }

    .month {
      width: 25%;
      text-align: right;
    }

    .day {
      width: 75%;
      text-align: left;

      &.ml {
        margin-left: 0.85em;
      }

      &.off {
        color: $grey-op3;
      }
    }
  }

  .time,
  .event {
    width: 20%;
    font-weight: 600;

    &.emekareBg {
      font-size: 0.9em;
    }
  }

  .event {
    color: white;
    font-weight: 600;
    margin-right: 0.5 * $rem;
    position: relative;

    @media screen and (min-width: 1024px) {
      margin-right: 0.5rem;
    }

    &.blank {
      background-color: $white-op8;
    }

    &.off {
      background-color: $grey-op05;
    }

    @each $unit in $units {
      &.#{$unit}-circle {
        position: relative;

        &::before {
          position: absolute;
          content: "";
          right: 6 * $px;
          top: 6 * $px;
          width: 1.2 * $rem;
          height: 1.2 * $rem;
          z-index: 1;
          background: url(../../public/img/#{$unit}/circle-coaster.svg) no-repeat;
          background-size: 1.2 * $rem;

          @media screen and (max-width: 768px) {
            right: -6px;
            top: -4px;
            width: 2 * $rem;
            height: 2 * $rem;
            background-size: 2 * $rem;
          }

          @media screen and (min-width: 1024px) {
            right: 6px;
            top: 6px;
            width: 1.2rem;
            height: 1.2rem;
            background-size: 1.2rem;
          }
        }
      }
    }
  }
}


.curtain,
.bonus,
.ticket,
.ticket-early,
.ticket-playguide,
.attention {
  padding-left: 4rem;
  padding-right: 4rem;
  text-align: left;
  color: $black;
  font-size: 1rem;

  @media screen and (max-width: 768px) {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.9rem;
  }
}

.event-link-box {
  background: url(../../public/img/mre_menu.png) repeat-y;
  background-size: 100% auto;
  background-position: center top, center top;
  padding: 0.8rem;
  text-align: center;
  font-weight: 600;
  color: white;
  margin-top: 2rem;
  margin-bottom: 5rem;
  position: relative;
  transition: opacity 0.5s;
  opacity: 0.8;

  @media screen and (max-width: 768px) {
    margin-bottom: 3rem;
    height: 68px;
    padding-bottom: 0;
  }

  &:hover {
    cursor: pointer;
    opacity: 1;
  }

  &::before,
  &::after {
    position: absolute;
    content: "";
    background: url(../../public/img/title_mre.png) no-repeat;
    width: 44px;
    height: 100px;
    bottom: 0;
    left: 0;
    opacity: 0.8;

    @media screen and (min-width: 1024px) {
      left: 0rem;
    }

    @media screen and (max-width: 768px) {
      left: 0;
      background-size: calc(44px * .8) 80px;
      height: 80px;
    }
  }

  &::after {
    transform: scaleX(-1);
    right: 0;
    left: unset;

    @media screen and (max-width: 768px) {
      right: 0;
    }
  }

  .copy {
    font-size: 1.1rem;

    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      margin-bottom: 0rem;
    }
  }

  .text {
    text-transform: uppercase;
    font-size: 2.6rem;
    margin-top: -0.25rem;
    margin-bottom: -1.4rem;

    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
      margin-bottom: -0.7rem;
      margin-top: -0.25rem;
    }
  }
}

.sq {
  color: $liteorange;
  margin-right: 0.2em;
}

.bonus {
  .circle {
    width: 1.2rem;
    height: 1.2rem;
    display: inline;
    transform: translateY(3px);
    margin-right: 0.2em;
  }
}

.ticket {
  &-note {
    font-weight: 600;
  }

  .item {
    @media screen and (max-width: 768px) {
      margin-bottom: 0.5rem;
    }
  }

  .seat-s {
    margin-right: 1px;
  }

  .seat-b {
    margin-right: 1px;
  }

  .bench {
    margin-right: -0.5px;
  }

  .seat-2f {
    margin-right: 2px;
  }

  &-note {
    .sq {
      margin-right: 0;
    }
  }

  .event-link {
    text-transform: uppercase;
    transition: 0.33s;

    &:hover {
      cursor: pointer;
      transition: 0.33s;
      color: $black;
    }
  }
}

.ticket-early,
.ticket-playguide {
  .item:not(:first-child) {
    margin-bottom: 2rem;
  }

  li {
    font-size: 0.8em;
  }
}

.ticket-playguide {
  margin-bottom: 4rem;
}

.attention {
  margin-top: 4rem;
  width: 100%;

  @media screen and (max-width: 768px) {
    margin-top: 2rem;
  }
  &-inner {
    margin-top: 3rem;
    @media screen and (max-width: 768px) {
      margin-top: 1.75rem;
    }
  }
  &-inner,
  .resale-inner {
    border: 1px solid $liteorange;
    background-color: $white-op5;
    padding: 1.5rem 4rem 3rem;

    @media screen and (max-width: 768px) {
      padding-left: 1rem;
      padding-right: 1rem;
      padding-bottom: 2rem;
    }
  }

  .resale-inner {
    margin-bottom: 3rem;
    @media screen and (max-width: 768px) {
      margin-bottom: 1.5rem;
    }
    .resale-text {
      font-size: 0.8rem;
      line-height: 1.7;
    }
  }

  .head2 {
    font-size: 1.1rem;
  }

  .text {
    margin-top: 2rem;
    font-size: 0.9rem;
    line-height: 2;

    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
  }

  &-info {
    margin-top: 2rem;
    font-size: 0.9rem;
    padding-bottom: 3rem;
  }
}

.footer-bar {
  font-size: 0.7rem;
  background: url(../../public/img/mre_menu.png) no-repeat;
  background-size: 100% 100%;
  background-position: center top;
  opacity: 0.8;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);

  .text {
    padding: 1rem 0;
    font-size: 0.7rem;
    padding-left: 4rem;
    padding-right: 4rem;
    color: white;
  }
}</style>